// Auto-generated from translation.csv; do not edit manually
export const frFR = {
  "accountGuide": {
    "content": "Ouvrez n'importe quel jeu du groupe Touka, allez dans les paramètres du jeu, liez votre email, et profitez des offres spéciales !",
    "title": "Comment créer un compte ?"
  },
  "bottomNav": {
    "home": "Accueil",
    "myOrders": "Mes commandes"
  },
  "common": {
    "loading": "Chargement...",
    "noData": "Aucune donnée"
  },
  "footer": {
    "language": "Chinois (simplifié)",
    "privacyPolicy": "Politique de confidentialité",
    "termsOfService": "Conditions de service",
    "userSupport": "Support utilisateur",
    "downloadNow": "Télécharger maintenant !"
  },
  "header": {
    "characterName": "Nom du personnage",
    "gameServer": "Serveur de jeu",
    "selectGameServer": "Sélectionner la région du jeu",
    "greeting": "Bonjour",
    "loginPrompt": "Veuillez cliquer pour vous connecter",
    "switchServer": "Changer",
    "title": "Plateforme de recharge de jeu",
    "logout": "Se déconnecter"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Retour à la boutique du jeu",
    "empty": "Pas de commandes pour le moment",
    "filter": {
      "all": "Tout",
      "closed": "Fermé",
      "completed": "Terminé",
      "inProgress": "En cours",
      "pendingDelivery": "En attente d'expédition"
    },
    "orderTime": "Heure de commande:",
    "status": {
      "cancelled": "Annulé",
      "completed": "Transaction terminée",
      "paid": "Payé",
      "pending": "En attente de paiement",
      "shipped": "Expédié"
    }
  },
  "home": {
    "selectGame": "Choisissez le jeu auquel vous souhaitez recharger",
    "selectGameParts": {
      "prefix": "Choisissez le jeu auquel vous souhaitez ",
      "keyword": "recharger",
      "suffix": ""
    },
    "noRoleAccount": "Vous n'avez pas encore de personnage dans ce jeu. Veuillez en créer un dans le jeu avant d'acheter.",
    "noRoleRefreshPrefix": "Compte déjà créé ? Appuyez sur ",
    "noRoleRefreshAction": "Actualiser",
    "noRoleRefreshing": "Actualisation…",
    "noRoleRefreshNotFound": "Aucune information de personnage trouvée",
    "noRoleRefreshFailed": "Échec de l’actualisation. Veuillez réessayer plus tard."
  },
  "login": {
    "agreeTerms": {
      "and": "et",
      "prefix": "J'ai lu et accepte",
      "privacy": "Politique de confidentialité",
      "terms": "Conditions de service"
    },
    "cancel": "Annuler",
    "bindGameGuide": "Notice de liaison au jeu",
    "bindGameGuideContent": "Ouvrez n’importe quel jeu Touka,\nallez dans les paramètres du jeu,\nliez votre adresse e-mail\net profitez des promotions sur la boutique !",
    "captchaPlaceholder": "Code de vérification",
    "invalidCaptcha": "Veuillez saisir un code de vérification à 4 chiffres",
    "email": "Email",
    "emailNotBound": "Échec de la récupération, veuillez entrer l'email lié dans le jeu~",
    "emailPlaceholder": "Veuillez entrer votre adresse email",
    "keepLogin": "Rester connecté pendant 15 jours",
    "loading": "Connexion en cours...",
    "loginToStore": "Connexion à Touka Store",
    "noAccount": "Pas encore de compte ?",
    "password": "Mot de passe",
    "passwordPlaceholder": "Veuillez entrer le mot de passe",
    "submit": "Se connecter",
    "title": "Se connecter",
    "invalidEmail": "Veuillez saisir une adresse e-mail valide"
  },
  "logout": {
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "dontRemind": "Ne plus rappeler la prochaine fois",
    "messageLine1": "Après la déconnexion, sur tous les appareils des 30 derniers jours",
    "messageLine2": "L'état de connexion sera perdu.",
    "title": "Petit rappel amical"
  },
  "menu": {
    "contactSupport": "Contacter le service client",
    "gameList": "Liste des jeux",
    "myOrders": "Mes commandes"
  },
  "paymentSuccess": {
    "account": "Compte :",
    "confirm": "Confirmer",
    "getPaymentInfoFailed": "Échec de l'obtention des informations de paiement",
    "loading": "Chargement...",
    "orderDate": "Date de la commande :",
    "orderId": "Numéro de commande :",
    "paymentMethod": "Mode de paiement :",
    "paypal": "PayPal",
    "price": "Prix :",
    "purchaseContent": "Contenu de l'achat :",
    "quantity": "Quantité achetée :",
    "serverAndCharacter": "Serveur / Personnage :",
    "title": "Merci pour votre achat",
    "total": "Tout :",
    "unionPay": "UnionPay",
    "amountPaid": "Montant payé :",
    "closeModal": "Fermer"
  },
  "productModal": {
    "confirm": "Confirmer",
    "purchaseDetails": "Détails de l'achat",
    "quantity": "Quantité :",
    "total": "Tout :",
    "unitPrice": "Prix unitaire :"
  },
  "products": {
    "giftPacks": "Pack cadeau",
    "diamond": "Diamant",
    "products": "Produit",
    "vouchers": "Coupon",
    "limitShort": "Limite",
    "remainingShort": "Reste",
    "howToUseVouchers": "Comment utiliser les coupons ?",
    "voucherGuide": {
      "title": "Comment utiliser les coupons ?",
      "step1": "1.Veuillez consulter les coupons achetés dans la boîte aux lettres du jeu.",
      "step2": "2.Vous pouvez voir le nombre de vos coupons en haut de l'onglet boutique du jeu. Lorsque le nombre de vos coupons atteint la quantité requise pour acheter un pack cadeau, les coupons seront utilisés en priorité pour l'achat.",
      "backToProducts": "Retour à la liste des produits"
    }
  },
  "purchaseConfirm": {
    "card": "Carte de crédit / Carte de débit",
    "confirm": "Confirmer",
    "dontAskAgain": "Ne plus demander dans les 30 jours",
    "gameServer": "Serveur de jeu ",
    "paymentMethods": "Modes de paiement pris en charge ",
    "paypal": "PayPal ",
    "title": "Êtes-vous sûr d'acheter via ce compte ? ",
    "unionPay": "Carte UnionPay "
  },
  "serverSelect": {
    "characterLabel": "Nom du personnage ",
    "characterPlaceholder": "Veuillez sélectionner un personnage ",
    "confirm": "Confirmer ",
    "noResults": "Aucun résultat pour le moment ",
    "serverPlaceholder": "Veuillez saisir le nom du serveur pour rechercher ",
    "title": "Sélectionner la région du jeu ",
    "title": "Sélectionner le serveur de jeu "
  },
  "support": {
    "cancel": "Annuler ",
    "copied": "Copié ",
    "copy": "Copie en un clic ",
    "description": "Veuillez envoyer vos informations détaillées par email officiel ",
    "title": "Support client "
  },
  "verification": {
    "back": "Retour ",
    "enterCode": "Veuillez saisir le code de vérification pour continuer ",
    "incorrectCode": "Code de vérification incorrect ",
    "invalidCode": "Veuillez saisir un code de vérification à 6 chiffres ",
    "noCode": "Vous ne recevez pas le code de vérification ? ",
    "sentTo": "Le code de vérification a été envoyé à ",
    "submit": "Soumettre ",
    "submitting": "Soumission en cours..."
  }
} as const;
